import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { Window, WindowHeader, WindowContent, Button } from 'react95';
import { useNavigate } from 'react-router-dom';
import ArtworkGrid from './ArtworkGrid';
import mo from '../Components/image/ChatGPT Image Jul 24, 2025, 06_40_45 PM.png';
import './ArtistSubmission.css';

export default function ArtistPage() {
  const { wallet } = useParams();
  const [artistName, setArtistName] = useState('');
  const [artworks, setArtworks] = useState([]);
  const navigate = useNavigate();

  const handleBack = () => {
    // Try to go back one page
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback: Navigate to the gallery
      navigate('/Anime-Art-Hub');
    }
  };

  useEffect(() => {
    async function fetchArtistData() {
      const { data: artworksData, error } = await supabase
        .from('artworks')
        .select('*')
        .eq('wallet', wallet);

      if (error) {
        console.error('Error fetching artworks:', error);
        return;
      }

      if (artworksData.length > 0) {
        setArtistName(artworksData[0].title || 'Unknown Artist');
        setArtworks(artworksData);
      }
    }
    fetchArtistData();
  }, [wallet]);

  if (artworks.length === 0) return <div>Loading...</div>;

  return (
    <div className='container'>
      <h1 className='centerani'>$ANI Artist Portal</h1>
      <Window className='artist-window'>
        <WindowHeader className='artist-header'>
          Artworks by {artistName}
          <Button className='close-button' onClick={handleBack}>
            x
          </Button>
        </WindowHeader>
        <WindowContent>
          <ArtworkGrid artworks={artworks} />
          <Button onClick={handleBack}>Back to Gallery</Button>
        </WindowContent>
      </Window>
      <div className='video-background mobile-bg'>
        <img src={mo} alt='Mobile Background' className='image-content' />
        <div className='overlay'></div>
      </div>
    </div>
  );
}
